/**
 * Labstep
 *
 * @module components/PurchaseOrder/EmptyState
 * @desc Empty state for purchase order
 */

import { PurchaseOrderActionCreate as PurchaseOrderCreateAction } from 'labstep-web/components/PurchaseOrder/Action/Create';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { PurchaseOrder } from 'labstep-web/models/purchase-order.model';
import type React from 'react';
import type { IPurchaseOrderEmptyStateProps } from './types';

export const PurchaseOrderEmptyState: React.FC<
  IPurchaseOrderEmptyStateProps
> = (props) => (
  <CardEmptyState
    title={`No ${PurchaseOrder.getHumanReadableEntityName(true)}`}
    explanation={
      <div>
        Group your order requests into orders to make them easier to
        track and manage. If you are interested in having your orders
        fulfilled by Labstep contact{' '}
        <a href="mailto:ordering@labstep.com">ordering@labstep.com</a>
      </div>
    }
    src="/img/empty-state/orders.svg"
    action={<PurchaseOrderCreateAction />}
    {...props}
  />
);
